import Listing from 'app/shared/model/Listing';
import Pager from 'app/shared/model/Pager';
import Conversation from 'app/shared/model/Conversation';

const LeadsAll = ({
    currentStartDateString = '',
    endDate = '',
    conversations = [],
    listingByListingId = {},
    nextStartDateString = '',
    phoneCallsByGuid = {},
    pager = {},
    startDate = {},
    queryFullConversationCount = 0,
    pageConversationCount = 0,
} = {}) => {
    // loop through object keys
    for (const key in Object.keys(listingByListingId)) {
        // cast object as listing model
        if (listingByListingId.hasOwnProperty(key)) {
            listingByListingId[key] = Listing(listingByListingId[key]);
        }
    }

    return {
        currentStartDateString: String(currentStartDateString),
        endDate: String(endDate),
        conversations: conversations.map(item => Conversation(item)),
        listingByListingId,
        nextStartDateString: String(nextStartDateString),
        phoneCallsByGuid: Object(phoneCallsByGuid),
        pager: Pager(pager),
        startDate: String(startDate),
        queryFullConversationCount: Number(queryFullConversationCount),
        pageConversationCount: Number(pageConversationCount),
    };
};

export default LeadsAll;
